
import { baseApi } from "./baseApi";

const VEHICLE_BASE_URL = "/vehicles";

export const vehicleApi = baseApi.injectEndpoints({
  tagTypes: ["Vehicle"],

  endpoints: (build) => ({
    addVehicle: build.mutation({
      query: (body) => ({
        url: VEHICLE_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Vehicle", id: "LIST" }],
    }),
    listVehicles: build.query({
      query: (params) => ({
        url: VEHICLE_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.invalidatesTags
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Vehicle, _id" })),
              { type: "Vehicle", id: "LIST" },
            ]
          : [{ TYPE: "Vehicle", id: "LIST" }],
    }),
    getDDLVehicleList: build.query({
      query: (params) => ({
        url: `${VEHICLE_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data.map(({ _id }) => ({ type: "Vehicle", _id })),
              { type: "Vehicle", id: "DDL" },
            ]
          : [{ type: "Vehicle", id: "DDL" }],
    }),
    getDDLVehicleListForVehicleFuel: build.query({
      query: (params) => ({
        url: `${VEHICLE_BASE_URL}/ddlForVehicleFuel`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data.map(({ _id }) => ({ type: "Vehicle", _id })),
              { type: "Vehicle", id: "DDL" },
            ]
          : [{ type: "Vehicle", id: "DDL" }],
    }),

    getVehicleDetail: build.query({
      query: (id) => `${VEHICLE_BASE_URL}/${id}`,
      providesTags: (_result, _error, { _id }) => [
                { type: "Vehicle", id: _id },
                { type: "Vehicle", id: "LIST" },
            ],
    }),

    updateVehicle: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${VEHICLE_BASE_URL}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Vehicle", id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
    // Vehicle history
    addVehicleHistory: build.mutation({
      query: (payload) => {
        const { vehicleId, ...body } = payload;

        return {
          url: `${VEHICLE_BASE_URL}/${vehicleId}/history`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { vehicleId }) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    updateVehicleHistory: build.mutation({
      query: (payload) => {
        const { vehicleId, maintenanceId, ...body } = payload;

        return {
          url: `${VEHICLE_BASE_URL}/${vehicleId}/history/${maintenanceId}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { vehicleId }) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    // Vehicle history
    getVehicleHistory: build.query({
      query: (vehicleId) => `${VEHICLE_BASE_URL}/${vehicleId}/history`,
      providesTags: (result, error, vehicleId) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    // Example in your vehicleApi service file

    // Adding new Vehicle Insurance
    addVehicleInsurance: build.mutation({
      query: (payload) => {
        const { vehicle_id, ...body } = payload;
        return {
          url: `${VEHICLE_BASE_URL}/${vehicle_id}/vehicleInsurances`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Vehicle", id: _id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    // Updating existing Vehicle Insurance
    updateVehicleInsurance: build.mutation({
      query: (payload) => {
        const { vehicle_id, insurance_id, ...body } = payload; // Extract insuranceId and other fields
        return {
          url: `${VEHICLE_BASE_URL}/${vehicle_id}/vehicleInsurances`, // Endpoint for updating insurance
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Vehicle", id: _id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
    // add Vehicle Notes
    addVehicleNotes: build.mutation({
      query: (payload) => {
        const { vehicleId, ...body } = payload;

        return {
          url: `${VEHICLE_BASE_URL}/${vehicleId}/notes`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Vehicle", id: _id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    // Update Vehicle Note
    updateVehicleNotesY: build.mutation({
      query: ({ vehicleId, noteId, ...body }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/notes/${noteId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Vehicle", id: _id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),

    // New query to fetch notes by vehicleId
    listVehicleNotes: build.query({
      query: ({ vehicleId, page, limit }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/notes`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Vehicle", id: _id },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
  
    // New Vehicle Registration Endpoints
    addVehicleRegistration: build.mutation({
      query: ({ vehicleId, ...body }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/registrations`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { vehicleId }) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
    listVehicleRegistrations: build.query({
      query: ({ vehicleId, page, limit, active, vehicleType, registrationStatus }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/registrations`,
        params: { page, limit, active, vehicleType, registrationStatus },
      }),
      providesTags: (result, error, { vehicleId }) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "Vehicle", id: _id })),
              { type: "Vehicle", id: vehicleId },
              { type: "Vehicle", id: "LIST" },
            ]
          : [{ type: "Vehicle", id: vehicleId }, { type: "Vehicle", id: "LIST" }],
    }),
    getVehicleRegistration: build.query({
      query: ({ vehicleId, registrationId }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/registrations/${registrationId}`,
      }),
      providesTags: (result, error, { vehicleId, registrationId }) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: registrationId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
    updateVehicleRegistration: build.mutation({
      query: ({ vehicleId, registrationId, ...body }) => ({
        url: `${VEHICLE_BASE_URL}/${vehicleId}/registrations/${registrationId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { vehicleId, registrationId }) => [
        { type: "Vehicle", id: vehicleId },
        { type: "Vehicle", id: registrationId },
        { type: "Vehicle", id: "LIST" },
      ],
    }),
    addVehicleAndAssignToDriver: build.mutation({
  query: (body) => ({
    url: `${VEHICLE_BASE_URL}/assign-and-create`,
    method: "POST",
    body,
  }),
  invalidatesTags: [{ type: "Vehicle", id: "LIST" }],
}),
  }),

  overrideExisting: false,
});
export const {
  useListVehiclesQuery,
  useAddVehicleAndAssignToDriverMutation, // For Driver Portal (Partial Transfer Request) Vehicle Drop Down 
  useLazyListVehiclesQuery,
  useAddVehicleMutation,
  useLazyGetDDLVehicleListQuery,
  useLazyGetDDLVehicleListForVehicleFuelQuery,
  useAddVehicleHistoryMutation,
  useUpdateVehicleHistoryMutation,
  useAddVehicleInsuranceMutation,
  useUpdateVehicleInsuranceMutation,
  useGetVehicleDetailQuery,
  useUpdateVehicleMutation,
  useAddVehicleNotesMutation,
  useUpdateVehicleNotesYMutation,
  useLazyListVehicleNotesQuery,
  useAddFuelRecordMutation,
  useUpdateFuelRecordMutation,
  useGetFuelRecordsQuery,
  useLazyGetFuelRecordsQuery,

  // vehicle registration 
 useAddVehicleRegistrationMutation,
  useListVehicleRegistrationsQuery,
  useLazyListVehicleRegistrationsQuery,
  useGetVehicleRegistrationQuery,
  useUpdateVehicleRegistrationMutation,

} = vehicleApi;
